import { useContext } from 'react';
import { ConfigurationError } from '@cian/peperrors/shared';

import { Context } from './context';

export const useApplicationContext = () => {
  const context = useContext(Context);

  if (!context) {
    throw new ConfigurationError({
      message: `useApplicationContext used outside of it's context`,
      domain: 'useApplicationContext',
    });
  }

  return context;
};
